import { Routes } from '@angular/router';
import { GeoLocationAdapter } from '@app/api-v2/geo/geo-location.adapter';
import { WebGeoLocation } from '@app/api-v2/geo/web-geo-location';

export const DESKTOP_DETAIL_PAGE_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import(
        '../pages/desktop-web-property-detail/desktop-web-property-detail.component'
      ).then((m) => m.DesktopWebPropertyDetailComponent),
    providers: [{ provide: GeoLocationAdapter, useClass: WebGeoLocation }],
  },
];
